function displayProgressBar() {
    if (document.getElementById('progress-bar')) {
    }
    else {
        $('body').append(`<div class="progress-bar" id="progress-bar"><div class="progress"><span class="percent"></span></div></div>`);
    }
    document.getElementById('progress-bar').style.display = "block";
}
function displayEndingProgressBar() {
    var actualProgresBar = document.getElementById('progress-bar');
    if (actualProgresBar) {
        actualProgresBar.remove();
    }
    $('body').append(`<div class="ending-progress-bar" id="progress-bar"><div class="progress"><span class="percent"></span></div></div>`);

    setTimeout(function () {
        document.getElementById('progress-bar').remove();
    }, 1000);

    document.getElementById('progress-bar').style.display = "block";
}
function removeProgressBar() {
    document.getElementById('progress-bar').remove();
}

function displayLoadRing(element) {
    $(element).append(`<div class="lds-ring" style="margin-left: 5px;"><div></div><div></div><div></div><div></div></div>`);
}
function removeLoadRing(element) {
    element.getElementsByClassName('lds-ring')[0].remove();
}


function displayLoadingBars(element) {
    if (document.getElementById('loadingBars') == null) {
        $(element).append(`<div class="loadingBars" id="loadingBars"></div>`);
    }
}
function removeLoadingBars() {
    var loadingBars = document.getElementById('loadingBars');
    if (loadingBars) {
        loadingBars.remove();
    }
}   